module.exports = __webpack_public_path__ + "img/Miimu logo.faf440f6.png";